var $ = require('../internals/export');

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$({ target: 'Number', stat: true }, {
  EPSILON: Math.pow(2, -52)
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.number.epsilon.js
// module id = 739
// module chunks = 49